<div class="row justify-content-center">
  <div class="col-xl-12">
    <div class="card auth-card error-card mb-0">
      <div class="card-body p-0">
        <div style="height: 99.8vh;" class="row align-items-center g-0">
          <div class="col-lg-6 d-none d-lg-inline-block border-end">
            <div class="auth-page-sidebar">
              <img
                src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif"
                alt="auth"
                class="img-fluid"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="p-4">
              <div class="mx-auto mb-4 text-center">
                <app-logo-box
                  className="mx-auto text-center auth-logo"
                  height="24"
                  logoHeight="30"
                />

                <h1 class="mt-5 mb-3 fw-bold fs-60">404</h1>
                <h2 class="fs-22 lh-base">Page Not Found !</h2>
                <p class="text-muted mt-1 mb-4">
                  The page you're trying to reach seems to have gone
                  <br />
                  missing in the digital wilderness.
                </p>

                <div class="text-center">
                  <a routerLink="/" class="btn btn-success">Go Back</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
